<template>
  <el-dialog title="七天风险"
             :visible.sync="params.flag"
             v-dialogDrag
             :modal="false"
             :close-on-click-modal="false"
             :lock-scroll="false"
             :modal-append-to-body=false
             :append-to-body="false"
             ref="jsfxRef"
             custom-class="sdrf"
  >
    <div class="main">
      <seven-day-risk-forecast></seven-day-risk-forecast>
    </div>
  </el-dialog>
</template>
<script>
import SevenDayRiskForecast from '@/components/module/card/seven-day-risk-forecast.vue'

export default {
  components: { SevenDayRiskForecast },
  props: ['params'],
  data () {
    return {
      rootFontSize: window.rootFontSize
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
        }
      },
      immediate: true
    }
  },
  computed: {},
  mounted () {
    this.setZindex()
  },
  methods: {
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.jsfxRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }

}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    pointer-events: auto;
  }
}
</style>
